import { markRaw } from 'vue';
import { PhBicycle, PhStorefront, PhCheers, PhPicnicTable, PhHandArrowDown, PhBookOpen, PhUmbrella } from '@phosphor-icons/vue';

const EVENT_TYPE = "0e";
const TAKE_AWAY_TYPE = 0;
const DELIVERY_TYPE = 1;
const TABLE_ORDER_TYPE = "0t";
const ETC_TABLE_ORDER_TYPE = "etc-tablebooking";
const DIGITAL_MENU_TYPE = "0mt";
const PICKUP_TYPE = 20;
const CUSTOM_TYPE = "dcf";

export function useOrder() {

  async function getMethodIcon({ type: _methodType, icon }, cast = false) {
    if (icon) {
      // Try to resolve known icons first
      switch (icon) {
        case 'PhUmbrella':
          return markRaw(PhUmbrella);
        default:
          try {
            // Dynamically import the icon from phosphor-icons/vue
            const module = await import('@phosphor-icons/vue');
            if (module[icon]) {
              return markRaw(module[icon]);
            }
            return null;
          } catch (e) {
            return null;
          }
      }
    }

    if (cast) {
      try {
        _methodType = parseInt(_methodType);
      } catch (e) {
        _methodType = _methodType;
      }
    }

    switch (_methodType) {
      case METHODS.DELIVERY_TYPE:
        return markRaw(PhBicycle);
      case METHODS.PICKUP_TYPE:
        return markRaw(PhStorefront);
      case METHODS.EVENT_TYPE:
        return markRaw(PhCheers);
      case METHODS.TABLE_ORDER_TYPE:
      case METHODS.ETC_TABLE_ORDER_TYPE:
        return markRaw(PhPicnicTable);
      case METHODS.TAKE_AWAY_TYPE:
        return markRaw(PhHandArrowDown);
      case METHODS.DIGITAL_MENU_TYPE:
        return markRaw(PhBookOpen);
    }
    return null;
  }

  return {
    getMethodIcon,
    EVENT_TYPE,
    TAKE_AWAY_TYPE,
    DELIVERY_TYPE,
    TABLE_ORDER_TYPE,
    ETC_TABLE_ORDER_TYPE,
    DIGITAL_MENU_TYPE,
    PICKUP_TYPE,
    CUSTOM_TYPE,
  }
}

export const METHODS = {
  EVENT_TYPE,
  TAKE_AWAY_TYPE,
  DELIVERY_TYPE,
  TABLE_ORDER_TYPE,
  ETC_TABLE_ORDER_TYPE,
  DIGITAL_MENU_TYPE,
  PICKUP_TYPE,
  CUSTOM_TYPE
}

export const STATUS = {
  TEMP: 'temp',
  DELIVERED: 'delivered',
  PICKEDUP: 'pickedup',
  ORDERED: 'ordered',
}
